module.exports = __webpack_public_path__ + "static/media/img_gift.7f4da3c5.svg";